import { push } from '@rea-argonaut/link';
import type { AnchorHTMLAttributes, FunctionComponent } from 'react';
import type { StyleFunction } from 'styled-components';
import styled, { css } from 'styled-components';

type PcaLinkVariant = 'plain';
type StyledLinkProps = Omit<PcaLinkProps, 'to'> & { $variant?: PcaLinkVariant };

const getPcaLinkStyles: StyleFunction<StyledLinkProps> = ({ $variant }) => {
  if ($variant === 'plain')
    return css`
      width: 100%;
      text-decoration: none;
      &:hover {
        text-decoration: none;
      }
    `;
  return '';
};

const StyledLink = styled.a<StyledLinkProps>`
  ${getPcaLinkStyles}
`;

const isModifiedEvent = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>): boolean => {
  return event.metaKey || event.altKey || event.ctrlKey || event.shiftKey;
};

export interface PcaLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
  clientSideRouting?: boolean;
  anchorVariant?: PcaLinkVariant;
  className?: string;
}

export const PcaLink: FunctionComponent<PcaLinkProps> = ({
  children,
  to,
  clientSideRouting = false,
  anchorVariant: variant,
  onClick,
  ...rest
}) => {
  const onClickNavigate = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>): void => {
    if (clientSideRouting && rest?.target !== '_blank') {
      if (!isModifiedEvent(e)) {
        e.preventDefault();
        // Push the navigation to the next tick to speed up INP
        requestAnimationFrame(() => {
          setTimeout(() => {
            push(to);
          }, 0);
        });
      }
    }

    onClick?.(e);
  };

  return (
    <StyledLink {...rest} href={to} onClick={onClickNavigate} $variant={variant}>
      {children}
    </StyledLink>
  );
};
